import ApiResourceManager from '../ApiResourceManager';

export default class BrandConfigManager extends ApiResourceManager {
  // `host` wins over `partner` server-side: on a partner's own host the hostname is the
  // stronger statement, and a slug can be a stale value this tab kept from elsewhere.
  get = ({ partner = null, host = null }) =>
    this.request({
      method: 'GET',
      url: '/brand-config',
      params: { partner, host },
    });
}
